import React from 'react';

import { Skeleton as ShadSkeleton } from '@/components/ui/skeleton';

const COLUMN_COUNT = 3;

const Header = () => <ShadSkeleton className="h-[40px] mb-4 rounded-full" />;
const DropTarget = () => <ShadSkeleton className="flex-1 rounded-xl" />;

const Column = () => (
  <div className="flex flex-col w-[325px]">
    <Header />
    <DropTarget />
  </div>
);

const AddColumnButton = () => (
  <div className="flex h-[40px] items-center">
    <ShadSkeleton className="h-[36px] rounded-xl w-[36px]" />
  </div>
);

const Skeleton = () => (
  <div className="flex gap-4 h-full">
    {Array.from({ length: COLUMN_COUNT }, (_, i) => (
      <Column key={i} />
    ))}

    <AddColumnButton />
  </div>
);

export default Skeleton;
